export const PROXY_KEY = import.meta.env.VITE_RAPIDAPI_KEY;
console.log("RapidAPI key:", PROXY_KEY);

export const FETCH_BOOK_HOST = import.meta.env.VITE_RAPIDAPI_HOST;
/*
export const PROXY_URL_BY_KEYWORD = "https://goodreads-api-latest-updated.p.rapidapi.com/search?";
export const PROXY_URL_BY_ID = "https://goodreads-api-latest-updated.p.rapidapi.com/book/";
export const PROXY_HOST_1 = "goodreads-api-latest-updated.p.rapidapi.com";
*/
export const FETCH_BY_ID = "https://goodreads12.p.rapidapi.com/getBookByID?";
export const FETCH_BY_KEYWORD = "https://goodreads12.p.rapidapi.com/searchBooks?";


export const optionsFetchAPI = {
        method: 'GET',
        headers: {
          'x-rapidapi-key': PROXY_KEY,
          'x-rapidapi-host': FETCH_BOOK_HOST,
        }
      };